import PhoneInput from 'mui-phone-input';
import React from 'react';

import { noop } from '@/utility/noop';

interface Props {
  readonly id?: string;
  readonly label?: string;
  readonly name?: string;
  readonly value?: unknown;
  readonly defaultValue?: unknown;
}

export const PhoneNumberFormFieldInput: React.FC<Props> = (props: Props): React.ReactElement => {
  const { id, label, name, value } = props;

  if (value !== undefined) {
    throw new Error('PhoneNumberInput can only be uncontrolled');
  }

  const defaultValue = React.useMemo((): string => {
    if (props.defaultValue === null) {
      return '';
    }

    return String(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <PhoneInput
      id={id}
      InputProps={removeInputProps}
      fullWidth={true}
      variant="outlined"
      disableDropdown={true}
      name={name}
      label={label}
      value={defaultValue.slice(1)}
      onChange={noop}
    />
  );
};

const removeInputProps = {};
